import * as _ from 'lodash';
import { AbstractFetcher } from './fetcher.factory';

export class SimpleFetcher extends AbstractFetcher {
    retryCount;
    retryOnEmpty;
    retryTimeout;
    promise;

    /**
     * @param retryCount How many retries a fetch can have before it gets rejected
     * @param retryOnEmpty Whether an empty successful response should be counted as a fail and retried
     * @param retryTimeout How long the fetch should wait between retries
     */
    constructor(retryCount = 1, retryOnEmpty = false, retryTimeout = 1000) {
        super();

        this.retryCount = retryCount;
        this.retryOnEmpty = retryOnEmpty;
        this.retryTimeout = retryTimeout;
    }

    cancel() {
        if (this.promise) {
            SimpleFetcher.clearTimeout(this.promise);
        }
    }

    /**
     * Tells the fetcher to go an fetch an item with a given method
     * If the fetcher has been told to wait
     * @param func The function to run with params as an argument that returns a $promise object
     * @param params The params to call func with
     * @param delay The delay before the request is first made in milliseconds
     * @returns {Promise}
     */
    async fetch(func, params, delay = 0) {
        this.promise = SimpleFetcher.setTimeout(delay).then(() =>
            this._loopFetch(func, params, this.retryCount, this.retryOnEmpty, this.retryTimeout),
        );
        return this.promise;
    }

    async _loopFetch(func, params, retries, retryOnEmpty, retryTimeout) {
        return SimpleFetcher.resourceFetch(func, params)
            .then((response) => {
                if (response && (_.size(response) || !this.retryOnEmpty)) {
                    // The response is either not empty or we don't care if it is
                    return Promise.resolve(response);
                } else {
                    // If the response is empty, throw (moves to the catch block below)
                    throw new Error('empty');
                }
            })
            .catch((error) => {
                // Decrement the retry number, and either try again, or reject
                if (--retries >= 0) {
                    return SimpleFetcher.setTimeout(retryTimeout).then(() =>
                        this._loopFetch(func, params, retries, retryOnEmpty, retryTimeout),
                    );
                } else {
                    return Promise.reject(new Error(error));
                }
            });
    }

    // TODO This should be abstracted away somehow, maybe be given a path to the promise from the function
    static resourceFetch(func, params) {
        return func(params).$promise;
    }

    static setTimeout(delay) {
        return new Promise((resolve) => window.setTimeout(resolve, delay));
    }

    static clearTimeout(id) {
        return new Promise((resolve) => resolve((window as any).clearTimeout(id)));
    }
}
